






























import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import SurveyChart from '@/components/lfs/Statistics/Items/SurveysChart.vue'
import Chips from '@/components/lfs/Statistics/Items/Chips.vue'
import colors from '@/assets/colors.json'

  interface LooseObject {
    [key: string]: any
  }

const statistics = namespace('statistics')

@Component({
  name: 'c-surveys',

  components: {
    'c-survey-chart': SurveyChart,
    'c-chips': Chips
  }
})
export default class Surveys extends Vue {
  surveyFiltred: any = []
  isShow: boolean = false

  @statistics.Getter('getSurveyCount') surveyCount!: number

  get surveys () {
    return this.$store.getters['statistics/getSurveyStat']
      .sort((a: any, b: any) => {
        return a.count < b.count ? 1 : -1
      })
      .sort((a: any, b: any) => {
        return a.questionOrder > b.questionOrder ? 1 : -1
      })
      .map((item: any, index: number) => {
        return { color: colors[index], ...item }
      })
  }

  created () {
    this.createBlocksArr()
  }

  mounted() {
    this.isShow = true
  }

  @Watch('surveys')
  isSurveysChanged () {
    this.createBlocksArr()
  }

  protected createBlocksArr () {
    let blocks: LooseObject = {}

    this.surveys.forEach((element: any) => {
      const qText: string = element.questionText

      if (!blocks.hasOwnProperty(qText)) {
        blocks[qText] = {
          title: element.questionText,
          data: [],
          color: element.color
        }
      }

      blocks[qText].data.push({
        name: element.answerText,
        data: [element.count],
        color: element.color
      })
    })

    this.surveyFiltred = blocks
  }
}
